// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"798":"bb660542","880":"c2f7adc6"}[chunkId] + ".css";
};